module.exports = __webpack_public_path__ + "img/4.256742e9.jpg";